import React from "react";
import ReactDOM from "react-dom/client";
import { Playbook } from "./playbook";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><Playbook /></React.StrictMode>,
);
